import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import FileUpload from '@material-ui/icons/FileUpload';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import AutoComplete from '../../shared/AutoComplete';
import ErrorBar from '../../shared/ErrorBar';
import { convertIdToName } from '../../../helpers/convertIdToName';

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    margin: theme.spacing.unit,
  },
});


class VendorForm extends Component {

  state = {
      vendor_name: '',
      vendor_id: '',
      errMessages: this.props.errMessages,
    };

  componentWillReceiveProps(nextProps) {
    this.setState({
      errMessages: nextProps.errMessages
    });
  }

  onVendorSelect = vendor => {
    const vendor_id = this.props.vendors.filter(dataSet => {
      return dataSet.vendor_name.toLowerCase() === vendor.toLowerCase()
    });
    this.setState({ vendor_id: vendor_id[0].id.toString() });
  }

  onSubmit = e => {
    const { vendor_name, vendor_id } = this.state;
    e.preventDefault();
    if (this.props.editMode) {
      return this.props.onFormActionSubmit(
        {vendor_id, vendor_name}
      );
    }
    return this.props.onFormActionSubmit({
      vendor_name
    });
  }

  handleCloseError = (remove) => {
    const newErrMessages = this.state.errMessages.filter((errMessage, index) => index !== remove)
    this.setState({
      errMessages: newErrMessages
    });
  }

  handleChange = name => event => {
      this.setState({
        [name]: event.target.value,
      });
    };

  renderErrMessages() {
    return <ErrorBar messages={this.state.errMessages} onClick={this.handleCloseError}/>
  }

  render() {
    const { classes, editMode, role } = this.props;
    return (
      <div>
        <form>

        { editMode ?  (
          <AutoComplete suggestionCount={15} data={this.props.vendors} dataKey={'vendor_name'} unAuthorized={role !== 'admin'} onItemSelect={this.onVendorSelect} value={convertIdToName(this.state.vendor_id, this.props.vendors, "vendor_name")} fieldLabel="Vendor" />) : ''}
        <FormControl className={classes.formControl}>
        <InputLabel htmlFor="name-simple">Vendor Name</InputLabel>
        <Input id="name-simple" value={this.state.vendor_name} onChange={this.handleChange('vendor_name')} />
          </FormControl>
          {
            this.renderErrMessages()
          }
        </form>
        <Button variant="raised" disabled={this.props.loading || (editMode && this.props.role !== 'admin' )} color="primary" className={classes.button} onClick={this.onSubmit}>
          {this.props.loading ? <CircularProgress className={classes.progress} size={25} /> :
          <FileUpload className={classes.leftIcon} aria-label={editMode ? 'Update' : 'Create'} />
          }
          { editMode ? 'Update' : 'Create' }
        </Button>
      </div>
    );
  }
}

const mapStateToProps = ({ divisions, auth, errors, appLoading, vendors }) => {
  const { errMessage } = errors;
  const { loading } = appLoading;
  const errMessages = errMessage.split(", ")[0] === "" ? [] : errMessage.split(", ");
  const { role } = auth;
  return {
    vendors,
    loading,
    divisions,
    role,
    errMessages
  };
};


export default compose(
  withStyles(styles, {
    name: 'VendorForm',
}), connect( mapStateToProps ))(VendorForm);



// WEBPACK FOOTER //
// ./src/components/admin/vendors/VendorForm.js